import { create } from 'zustand';

export interface Toast { id: number; text: string; tone: 'ok' | 'error' | 'info'; action?: { label: string; run: () => void } }

export const useToasts = create<{ toasts: Toast[]; push(t: Omit<Toast, 'id'>): void; dismiss(id: number): void }>((set) => ({
  toasts: [],
  push(t) {
    const id = Date.now() + Math.random();
    set((s) => ({ toasts: [...s.toasts.slice(-2), { ...t, id }] }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })), t.tone === 'error' ? 6000 : 3200);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}));

export const toast = {
  ok: (text: string, action?: Toast['action']) => useToasts.getState().push({ text, tone: 'ok', action }),
  error: (text: string, action?: Toast['action']) => useToasts.getState().push({ text, tone: 'error', action }),
  info: (text: string) => useToasts.getState().push({ text, tone: 'info' }),
};

/** Short vibration on phones for scan/add feedback. */
export function haptic(ms = 12) {
  if ('vibrate' in navigator) navigator.vibrate?.(ms);
}
